import React from "react";
import styled from "styled-components";
import { FaLinkedin, FaGithub } from "react-icons/fa";

const FooterContainer = styled.footer`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.primary};
  padding: 80px;
  text-align: center;
  color: ${({ theme }) => theme.colors.footerText || "#fff"};
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 10px;

  a {
    color: ${({ theme }) => "#fff"};
    font-size: 24px;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: ${({ theme }) => theme.colors.secondary };
    }
  }
`;

const FooterLinks = styled.div`
  margin-bottom: 10px;

  a {
    color: ${({ theme }) => "#fff"};
    text-decoration: none;
    margin: 0 10px;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: ${({ theme }) => theme.colors.secondary || "#007bff"};
    }
  }
`;

const Copyright = styled.p`
  font-size: 14px;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <SocialIcons>
        <a href="https://www.linkedin.com/in/fabiansanabriaampuero/"><FaLinkedin /></a>
        <a href="https://https://github.com/FabianSanabria"><FaGithub /></a>
      </SocialIcons>
      <FooterLinks>
        <a href="#home">Inicio</a>
        <a href="#about-me">Sobre mí</a>
        <a href="#skills">Mis Competencias</a>
        <a href="#projects">Proyectos</a>
      </FooterLinks>
      <Copyright>© {new Date().getFullYear()} Fabian Sanabria. Todos los derechos reservados.</Copyright>
    </FooterContainer>
  );
};

export default Footer;
